<mat-toolbar color="primary" class="position-fixed">
  <div fxHide.gt-xs>
      <button mat-icon-button (click)="onToggleSidenav()">
          <mat-icon>menu</mat-icon>
      </button>
  </div>
  <div>
      <a routerLink="/">
        <span class="app-title">
          <img
            style="height: 45px;"
            src="./assets/images/logos/WHITE-VENNHEALTH.svg"
          />
          <!-- <label class="logo-text">VennHealth</label> -->
        </span>
      </a>
  </div>
  <span class="example-spacer"></span>
	<span flex></span>
	<div>
		<mat-icon style="font-size: 25px; vertical-align: middle; margin-bottom: 5px;">person</mat-icon>
		<span style="color: gray;">Welcome </span><span style="font-weight: bold;">{{userName}}</span>
	</div>
</mat-toolbar>
